import React from 'react';

import { Text } from '@reckon-web/text';

import { Dialog } from '../components/common/dialog';
import { useDeleteUserFilter as _useDeleteUserFilter } from '../data/useDeleteUserFilter';
import { GetUserFilterListResult } from '../data/useGetUserFilterList';

import { useDialog } from './use-dialog';

const ConfirmationDialog: React.FC<{
  name: string;
  onClose: (ok?: boolean) => void;
}> = ({ name, onClose }) => {
  return (
    <Dialog
      title={`Delete ${name}?`}
      cancelLabel="Cancel"
      onCancel={onClose}
      submitLabel="Yes, delete filter"
      submitTone="critical"
      onSubmit={() => onClose(true)}
    >
      <Text>This is a permanent action that cannot be undone.</Text>
    </Dialog>
  );
};

export const useDeleteUserFilter = () => {
  const [_deleteUserFilter] = _useDeleteUserFilter(); // TODO: handle loading and error states

  const [Dialog, openDialog] = useDialog();

  const deleteUserFilter = React.useCallback(
    async (userFilter: GetUserFilterListResult) => {
      if (
        !(await openDialog<boolean>(
          (props) => <ConfirmationDialog name={userFilter.name!} {...props} />,
          { size: 'small' }
        ))
      )
        return;

      return _deleteUserFilter({
        variables: {
          input: {
            cloudId: userFilter.cloudId || '',
          },
        },
      });
    },
    [_deleteUserFilter, openDialog]
  );

  return React.useMemo(
    () =>
      [Dialog, deleteUserFilter] as [typeof Dialog, typeof deleteUserFilter],
    [Dialog, deleteUserFilter]
  );
};
